import { render, staticRenderFns } from "./abatementReminder.vue?vue&type=template&id=2de77674"
import script from "./abatementReminder.vue?vue&type=script&lang=js"
export * from "./abatementReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports